import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import { BAM_PROMO_IFRAME_ID } from 'constants';
import Hero from '@alias/Hero';
import SearchContainer from 'common/search/SearchContainer';
import ScheduleModuleContainer from '@alias/ScheduleModuleContainer';
import playable from '@alias/Playable';
import BAMIFrame from 'webapp/common/BAMIFrame';
import heroSelector from 'common/selectors/heroSelector';
import { enableSearchSelector, apiEnvSelector } from 'common/selectors/appSelector';
import pageSelector, { showPromoSelector } from 'common/selectors/pageSelector';
import { entitlementsTrackingSelector } from 'common/selectors/analyticsSelectors';
import { isEmpty } from 'lib/util';
import { PlayerPlacement, PageType } from 'enums';
import { createDTCPaywallAction } from 'common/actions/authenticationActions';

const PlayableHero = playable(Hero);

class TopLayoutContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            promoShown: false
        };
    }

    componentDidUpdate() {
        const { promoShown } = this.state;
        const { dispatch } = this.props;
        // can't use `ref` for stateless component(BAMIFrame), so checking against real DOM element
        if (!promoShown && this.showPromo && document.getElementById(BAM_PROMO_IFRAME_ID)) {
            dispatch(createDTCPaywallAction({
                containerId: BAM_PROMO_IFRAME_ID
            }));
            if (!this.state.promoShown) {
                this.promoShown();
            }
        }
    }
    get showPromo() {
        const { page: { id }, showPromo: showPromoArg } = this.props;
        return showPromoArg && id === 'espnplus';
    }
    promoShown() {
        this.setState({ promoShown: true });
    }
    render() {
        const { hero: heroArg, apiEnv, showSearch, entitlementsTracking } = this.props;
        let hero = null;
        let search = null;
        let scheduleModule = null;

        if (this.showPromo) {
            hero = (
                <BAMIFrame id={BAM_PROMO_IFRAME_ID} />
            );
        } else if (!isEmpty(heroArg)) {
            hero = (
                <PlayableHero
                    content={heroArg}
                    playerPlacement={PlayerPlacement.HERO}
                    placement="inline-hero"
                    isHero
                />
            );
        }
        if (hero) {
            search = (
                <SearchContainer
                    apiEnv={apiEnv}
                    entitlementsTracking={entitlementsTracking}
                    pageType={PageType.HOME}
                    enabled={showSearch}
                />
            );
            scheduleModule = <ScheduleModuleContainer />;
        }
        const colCClassName = showSearch ? 'col-c' : 'col-c no-search';
        return (
            <div className="layout-bc">
                <section className="mobile-tablet-only">
                    {search}
                </section>
                <section className="col-b">
                    {hero}
                </section>
                <section className={colCClassName}>
                    {search}
                    {scheduleModule}
                </section>
            </div>
        );
    }
}

TopLayoutContainer.propTypes = {
    dispatch: PropTypes.func,
    page: PropTypes.object,
    hero: PropTypes.object,
    showSearch: PropTypes.bool,
    showPromo: PropTypes.bool,
    apiEnv: PropTypes.string,
    entitlementsTracking: PropTypes.object
};

const mapStateToProps = (state) => ({
    page: pageSelector(state),
    hero: heroSelector(state),
    showSearch: enableSearchSelector(state),
    showPromo: showPromoSelector(state),
    apiEnv: apiEnvSelector(state),
    entitlementsTracking: entitlementsTrackingSelector(state)
});

export default connect(mapStateToProps)(TopLayoutContainer);
export { TopLayoutContainer as BaseTopLayoutContainer };



// WEBPACK FOOTER //
// ./app/common/page/common/TopLayoutContainer.js